import { EventEmitter, Component, ViewEncapsulation, ChangeDetectionStrategy, ElementRef, Renderer2, ViewContainerRef, ChangeDetectorRef, ViewChild, HostListener, InjectionToken, Directive, ComponentFactoryResolver, Inject, Input, Output, NgModule } from '@angular/core';
import { createPopper } from '@popperjs/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/ngx-popperjs-options.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["popperViewRef"];
function NgxPopperjsContentComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r1.text, ɵngcc0.ɵɵsanitizeHtml);
} }
function NgxPopperjsContentComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵelementEnd();
} }
const _c1 = ["*", "*"];
function NgxPopperjsOptions() { }
if (false) {
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.appendTo;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.applyArrowClass;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.applyClass;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.ariaDescribe;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.ariaRole;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.boundariesElement;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.disableAnimation;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.disableDefaultStyling;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.hideOnClickOutside;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.hideOnMouseLeave;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.hideOnScroll;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.placement;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.popperModifiers;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.positionFixed;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.preventOverflow;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.showDelay;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.styles;
    /** @type {?|undefined} */
    NgxPopperjsOptions.prototype.trigger;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/ngx-popperjs-placements.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const NgxPopperjsPlacements = {
    TOP: "top",
    BOTTOM: "bottom",
    LEFT: "left",
    RIGHT: "right",
    TOPSTART: "top-start",
    BOTTOMSTART: "bottom-start",
    LEFTSTART: "left-start",
    RIGHTSTART: "right-start",
    TOPEND: "top-end",
    BOTTOMEND: "bottom-end",
    LEFTEND: "left-end",
    RIGHTEND: "right-end",
    AUTO: "auto",
    AUTOSTART: "auto-start",
    AUTOEND: "auto-end",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/ngx-popperjs-triggers.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const NgxPopperjsTriggers = {
    click: "click",
    hover: "hover",
    mousedown: "mousedown",
    none: "none",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-popperjs-content/ngx-popper-content.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxPopperjsContentComponent {
    /**
     * @param {?} elRef
     * @param {?} _renderer
     * @param {?} _viewRef
     * @param {?} _changeDetectorRef
     */
    constructor(elRef, _renderer, _viewRef, _changeDetectorRef) {
        this.elRef = elRef;
        this._renderer = _renderer;
        this._viewRef = _viewRef;
        this._changeDetectorRef = _changeDetectorRef;
        this.ariaHidden = "true";
        this.arrowColor = null;
        this.displayType = "none";
        this.id = `ngx_poppperjs_${++NgxPopperjsContentComponent.nextId}`;
        this.isMouseOver = false;
        this.onHidden = new EventEmitter();
        this.opacity = 0;
        this.popperOptions = (/** @type {?} */ ({
            disableAnimation: false,
            disableDefaultStyling: false,
            placement: NgxPopperjsPlacements.AUTO,
            boundariesElement: "",
            trigger: NgxPopperjsTriggers.hover,
            positionFixed: false,
            appendToBody: false,
            popperModifiers: []
        }));
        this.state = true;
        this._styleId = `${this.id}_style`;
    }
    /**
     * @return {?}
     */
    clean() {
        this.toggleVisibility(false);
        if (!this.popperInstance) {
            return;
        }
        this.popperInstance.destroy();
    }
    /**
     * @param {?=} classList
     * @return {?}
     */
    extractAppliedClassListExpr(classList = []) {
        /** @type {?} */
        const klassList = Array.isArray(classList) ? classList : typeof classList === typeof "" ? classList.replace(/ /, "").split(",") : [];
        return klassList.reduce((/**
         * @param {?} acc
         * @param {?} klass
         * @return {?}
         */
        (acc, klass) => {
            acc[klass] = !0;
            return acc;
        }), {});
    }
    /**
     * @return {?}
     */
    hide() {
        if (this.popperInstance) {
            this.popperInstance.destroy();
        }
        this.toggleVisibility(false);
        this.onHidden.emit();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.clean();
        if (this.popperOptions.appendTo && this.elRef && this.elRef.nativeElement && this.elRef.nativeElement.parentNode) {
            this._viewRef.detach();
            this.elRef.nativeElement.parentNode.removeChild(this.elRef.nativeElement);
        }
    }
    /**
     * @return {?}
     */
    onDocumentResize() {
        this.update();
    }
    /**
     * @return {?}
     */
    onMouseOver() {
        this.isMouseOver = true;
    }
    /**
     * @return {?}
     */
    show() {
        if (!this.referenceObject) {
            return;
        }
        /** @type {?} */
        const appendToParent = this.popperOptions.appendTo && document.querySelector(this.popperOptions.appendTo);
        if (appendToParent && this.elRef.nativeElement.parentNode !== appendToParent) {
            this.elRef.nativeElement.parentNode && this.elRef.nativeElement.parentNode.removeChild(this.elRef.nativeElement);
            appendToParent.appendChild(this.elRef.nativeElement);
        }
        /** @type {?} */
        const popperOptions = (/** @type {?} */ ({
            strategy: this.popperOptions.positionFixed ? "fixed" : "absolute",
            placement: this.popperOptions.placement,
            modifiers: [
                (/** @type {?} */ ({
                    name: "offset",
                    enabled: !0,
                    options: {
                        offset: [0, 8],
                    }
                })),
                (/** @type {?} */ ({
                    name: "arrow",
                    enabled: !0,
                    options: {
                        element: ".ngxp__arrow",
                        padding: 3
                    },
                    requires: ["arrow"]
                })),
            ]
        }));
        if (this.onUpdate) {
            popperOptions.onFirstUpdate = (/** @type {?} */ (this.onUpdate));
        }
        /** @type {?} */
        const boundariesElement = this.popperOptions.boundariesElement && document.querySelector(this.popperOptions.boundariesElement);
        if (popperOptions.modifiers && boundariesElement) {
            popperOptions.modifiers.push((/** @type {?} */ ({
                name: "preventOverflow",
                enabled: this.popperOptions.preventOverflow,
                options: {
                    boundary: boundariesElement
                }
            })));
        }
        if (popperOptions.modifiers) {
            /** @type {?} */
            const preventOverflowModifier = popperOptions.modifiers.find((/**
             * @param {?} v
             * @return {?}
             */
            (v) => v.name === "preventOverflow"));
            if (preventOverflowModifier && !preventOverflowModifier.enabled) {
                /** @type {?} */
                const hideModifier = popperOptions.modifiers.find((/**
                 * @param {?} v
                 * @return {?}
                 */
                (v) => v.name === "preventOverflow"));
                hideModifier && (hideModifier.enabled = !1);
            }
        }
        this._determineArrowColor();
        popperOptions.modifiers = popperOptions.modifiers.concat(this.popperOptions.popperModifiers);
        this.popperInstance = createPopper(this.referenceObject, this.popperViewRef.nativeElement, popperOptions);
        this.toggleVisibility(true);
        this._globalResize = this._renderer.listen("document", "resize", this.onDocumentResize.bind(this));
    }
    /**
     * @return {?}
     */
    showOnLeave() {
        this.isMouseOver = false;
        if (this.popperOptions.trigger !== NgxPopperjsTriggers.hover && !this.popperOptions.hideOnMouseLeave) {
            return;
        }
        this.hide();
    }
    /**
     * @param {?} state
     * @return {?}
     */
    toggleVisibility(state) {
        if (!state) {
            this.opacity = 0;
            this.displayType = "none";
            this.ariaHidden = "true";
            this.state = false;
        }
        else {
            this.opacity = 1;
            this.displayType = "block";
            this.ariaHidden = "false";
            this.state = true;
        }
        // tslint:disable-next-line:no-string-literal
        if (!this._changeDetectorRef["destroyed"]) {
            this._changeDetectorRef.detectChanges();
        }
    }
    /**
     * @return {?}
     */
    update() {
        this.popperInstance && ((/** @type {?} */ (this.popperInstance))).update();
    }
    // TODO: check if this function might have had a purpose (unused at this time)
    // private _clearGlobalResize() {
    //   this._globalResize && typeof this._globalResize === "function" && this._globalResize();
    // }
    /**
     * @protected
     * @return {?}
     */
    _createArrowSelector() {
        return `div#${this.id}.ngxp__container > .ngxp__arrow.ngxp__force-arrow`;
    }
    /**
     * @protected
     * @return {?}
     */
    _determineArrowColor() {
        if (!this.popperOptions.styles || this.arrowColor) {
            return !1;
        }
        /** @type {?} */
        const ruleValue = this.popperOptions.styles["background-color"] || this.popperOptions.styles.backgroundColor;
        if (this.arrowColor === ruleValue) {
            return !1;
        }
        this.arrowColor = ruleValue;
        /** @type {?} */
        let $style = (/** @type {?} */ (document.querySelector(`#${this._styleId}`)));
        /** @type {?} */
        const styleContent = this.arrowColor ?
            `${this._createArrowSelector()}:before { background-color: ${this.arrowColor}; }` : "";
        if (!$style) {
            $style = (/** @type {?} */ (document.createElement("style")));
            $style.id = this._styleId;
            $style.setAttribute("type", "text/css");
            document.head.append($style);
        }
        // tslint:disable-next-line:no-string-literal
        if ($style["styleSheet"]) {
            // tslint:disable-next-line:no-string-literal
            $style["styleSheet"].cssText = styleContent;
            // This is required for IE8 and below.
        }
        else {
            $style.innerHTML = styleContent;
        }
    }
}
NgxPopperjsContentComponent.ɵfac = function NgxPopperjsContentComponent_Factory(t) { return new (t || NgxPopperjsContentComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
NgxPopperjsContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxPopperjsContentComponent, selectors: [["popper-content"]], viewQuery: function NgxPopperjsContentComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c0, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popperViewRef = _t.first);
    } }, hostBindings: function NgxPopperjsContentComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseover", function NgxPopperjsContentComponent_mouseover_HostBindingHandler() { return ctx.onMouseOver(); })("mouseleave", function NgxPopperjsContentComponent_mouseleave_HostBindingHandler() { return ctx.showOnLeave(); });
    } }, ngContentSelectors: _c1, decls: 5, vars: 19, consts: [[3, "ngStyle", "ngClass"], ["popperViewRef", ""], ["class", "ngxp__inner", 3, "innerHTML", 4, "ngIf"], ["class", "ngxp__inner", 4, "ngIf"], ["data-popper-arrow", "", 1, "ngxp__arrow", 3, "ngClass"], [1, "ngxp__inner", 3, "innerHTML"], [1, "ngxp__inner"]], template: function NgxPopperjsContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c1);
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, NgxPopperjsContentComponent_div_2_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(3, NgxPopperjsContentComponent_div_3_Template, 2, 0, "div", 3);
        ɵngcc0.ɵɵelement(4, "div", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("display", ctx.displayType)("opacity", ctx.opacity);
        ɵngcc0.ɵɵclassProp("ngxp__container", !ctx.popperOptions.disableDefaultStyling)("ngxp__animation", !ctx.popperOptions.disableAnimation);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.popperOptions.styles)("ngClass", ctx.extractAppliedClassListExpr(ctx.popperOptions.applyClass));
        ɵngcc0.ɵɵattribute("id", ctx.id)("aria-hidden", ctx.ariaHidden)("aria-describedby", ctx.popperOptions.ariaDescribe || null)("role", ctx.popperOptions.ariaRole);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.text);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.text);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("ngxp__force-arrow", ctx.arrowColor);
        ɵngcc0.ɵɵproperty("ngClass", ctx.extractAppliedClassListExpr(ctx.popperOptions.applyArrowClass));
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgClass, ɵngcc1.NgIf], styles: ["popper-content{position:relative;display:block}.ngxp__container{display:none;position:absolute;border-radius:3px;border:1px solid grey;box-shadow:0 0 2px rgba(0,0,0,.5);padding:10px}.ngxp__container.ngxp__animation{-webkit-animation:150ms ease-out ngxp-fadeIn;animation:150ms ease-out ngxp-fadeIn}.ngxp__container>.ngxp__arrow,.ngxp__container>.ngxp__arrow:before{position:absolute;width:10px;height:10px;z-index:-1}.ngxp__container>.ngxp__arrow:before{transform:rotate(45deg);content:'';background-color:#fff;top:0;left:0}.ngxp__container[data-popper-placement^=top]>.ngxp__arrow{bottom:-4px}.ngxp__container[data-popper-placement^=bottom]>.ngxp__arrow{top:-4px}.ngxp__container[data-popper-placement^=left]>.ngxp__arrow{right:-4px}.ngxp__container[data-popper-placement^=right]>.ngxp__arrow{left:-4px}@-webkit-keyframes ngxp-fadeIn{0%{display:none;opacity:0}1%{display:block;opacity:0}100%{display:block;opacity:1}}@keyframes ngxp-fadeIn{0%{display:none;opacity:0}1%{display:block;opacity:0}100%{display:block;opacity:1}}"], encapsulation: 2, changeDetection: 0 });
NgxPopperjsContentComponent.nextId = 0;
/** @nocollapse */
NgxPopperjsContentComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: ViewContainerRef },
    { type: ChangeDetectorRef }
];
NgxPopperjsContentComponent.propDecorators = {
    popperViewRef: [{ type: ViewChild, args: ["popperViewRef", { static: !0 },] }],
    onMouseOver: [{ type: HostListener, args: ["mouseover",] }],
    showOnLeave: [{ type: HostListener, args: ["mouseleave",] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxPopperjsContentComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: "popper-content",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: "<div #popperViewRef\r\n     [attr.id]=\"id\"\r\n     [class.ngxp__container]=\"!popperOptions.disableDefaultStyling\"\r\n     [class.ngxp__animation]=\"!popperOptions.disableAnimation\"\r\n     [style.display]=\"displayType\"\r\n     [style.opacity]=\"opacity\"\r\n     [ngStyle]=\"popperOptions.styles\"\r\n     [ngClass]=\"extractAppliedClassListExpr(popperOptions.applyClass)\"\r\n     attr.aria-hidden=\"{{ariaHidden}}\"\r\n     [attr.aria-describedby]=\"popperOptions.ariaDescribe || null\"\r\n     attr.role=\"{{popperOptions.ariaRole}}\">\r\n    <div *ngIf=\"text\"\r\n         class=\"ngxp__inner\"\r\n         [innerHTML]=\"text\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n    <div *ngIf=\"!text\"\r\n         class=\"ngxp__inner\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n    <div class=\"ngxp__arrow\"\r\n         data-popper-arrow\r\n         [class.ngxp__force-arrow]=\"arrowColor\"\r\n         [ngClass]=\"extractAppliedClassListExpr(popperOptions.applyArrowClass)\"></div>\r\n\r\n</div>\r\n",
                styles: ["popper-content{position:relative;display:block}.ngxp__container{display:none;position:absolute;border-radius:3px;border:1px solid grey;box-shadow:0 0 2px rgba(0,0,0,.5);padding:10px}.ngxp__container.ngxp__animation{-webkit-animation:150ms ease-out ngxp-fadeIn;animation:150ms ease-out ngxp-fadeIn}.ngxp__container>.ngxp__arrow,.ngxp__container>.ngxp__arrow:before{position:absolute;width:10px;height:10px;z-index:-1}.ngxp__container>.ngxp__arrow:before{transform:rotate(45deg);content:'';background-color:#fff;top:0;left:0}.ngxp__container[data-popper-placement^=top]>.ngxp__arrow{bottom:-4px}.ngxp__container[data-popper-placement^=bottom]>.ngxp__arrow{top:-4px}.ngxp__container[data-popper-placement^=left]>.ngxp__arrow{right:-4px}.ngxp__container[data-popper-placement^=right]>.ngxp__arrow{left:-4px}@-webkit-keyframes ngxp-fadeIn{0%{display:none;opacity:0}1%{display:block;opacity:0}100%{display:block;opacity:1}}@keyframes ngxp-fadeIn{0%{display:none;opacity:0}1%{display:block;opacity:0}100%{display:block;opacity:1}}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { 
    /**
     * @return {?}
     */
    onMouseOver: [{
            type: HostListener,
            args: ["mouseover"]
        }], 
    /**
     * @return {?}
     */
    showOnLeave: [{
            type: HostListener,
            args: ["mouseleave"]
        }], popperViewRef: [{
            type: ViewChild,
            args: ["popperViewRef", { static: !0 }]
        }] }); })();
if (false) {
    /** @type {?} */
    NgxPopperjsContentComponent.nextId;
    /** @type {?} */
    NgxPopperjsContentComponent.prototype.ariaHidden;
    /** @type {?} */
    NgxPopperjsContentComponent.prototype.arrowColor;
    /** @type {?} */
    NgxPopperjsContentComponent.prototype.displayType;
    /** @type {?} */
    NgxPopperjsContentComponent.prototype.id;
    /** @type {?} */
    NgxPopperjsContentComponent.prototype.isMouseOver;
    /** @type {?} */
    NgxPopperjsContentComponent.prototype.onHidden;
    /** @type {?} */
    NgxPopperjsContentComponent.prototype.onUpdate;
    /** @type {?} */
    NgxPopperjsContentComponent.prototype.opacity;
    /** @type {?} */
    NgxPopperjsContentComponent.prototype.popperInstance;
    /** @type {?} */
    NgxPopperjsContentComponent.prototype.popperOptions;
    /** @type {?} */
    NgxPopperjsContentComponent.prototype.popperViewRef;
    /** @type {?} */
    NgxPopperjsContentComponent.prototype.referenceObject;
    /** @type {?} */
    NgxPopperjsContentComponent.prototype.state;
    /** @type {?} */
    NgxPopperjsContentComponent.prototype.text;
    /**
     * @type {?}
     * @protected
     */
    NgxPopperjsContentComponent.prototype._globalResize;
    /**
     * @type {?}
     * @protected
     */
    NgxPopperjsContentComponent.prototype._styleId;
    /** @type {?} */
    NgxPopperjsContentComponent.prototype.elRef;
    /**
     * @type {?}
     * @protected
     */
    NgxPopperjsContentComponent.prototype._renderer;
    /**
     * @type {?}
     * @protected
     */
    NgxPopperjsContentComponent.prototype._viewRef;
    /**
     * @type {?}
     * @protected
     */
    NgxPopperjsContentComponent.prototype._changeDetectorRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/ngx-popperjs-defaults.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const NGX_POPPERJS_DEFAULTS = new InjectionToken("NGX_POPPERJS_DEFAULTS");

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-popperjs/ngx-popperjs.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxPopperjsDirective {
    /**
     * @param {?} _viewContainerRef
     * @param {?} _changeDetectorRef
     * @param {?} _resolver
     * @param {?} _elementRef
     * @param {?} _renderer
     * @param {?=} _popperDefaults
     */
    constructor(_viewContainerRef, _changeDetectorRef, _resolver, _elementRef, _renderer, _popperDefaults = {}) {
        this._viewContainerRef = _viewContainerRef;
        this._changeDetectorRef = _changeDetectorRef;
        this._resolver = _resolver;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._popperDefaults = _popperDefaults;
        this.hideTimeout = 0;
        this.popperOnHidden = new EventEmitter();
        this.popperOnShown = new EventEmitter();
        this.popperOnUpdate = new EventEmitter();
        this.timeoutAfterShow = 0;
        this._eventListeners = [];
        this._globalEventListeners = [];
        this._popperContentClass = NgxPopperjsContentComponent;
        this._popperPlacement = NgxPopperjsPlacements.AUTO;
        this._shown = false;
        this._subscriptions = [];
        NgxPopperjsDirective.baseOptions = Object.assign(Object.assign({}, NgxPopperjsDirective.baseOptions), this._popperDefaults);
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set applyClass(newValue) {
        if (newValue === this._applyClass) {
            return;
        }
        this._applyClass = newValue;
        if (this._popperContent) {
            this._popperContent.popperOptions.applyClass = newValue;
            if (!this._shown) {
                return;
            }
            this._popperContent.popperInstance.setOptions(this._popperContent.popperOptions);
        }
    }
    /**
     * @return {?}
     */
    get applyClass() {
        return this._applyClass;
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set content(newValue) {
        if (newValue === this._content) {
            return;
        }
        this._content = newValue;
        if (this._popperContent) {
            if (typeof newValue === "string") {
                this._popperContent.text = newValue;
            }
            else {
                this._popperContent = newValue;
            }
        }
    }
    /**
     * @return {?}
     */
    get content() {
        return this._content;
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set disabled(newValue) {
        if (newValue === this._disabled) {
            return;
        }
        this._disabled = !!newValue;
        if (this._shown) {
            this.hide();
        }
    }
    /**
     * @return {?}
     */
    get disabled() {
        return this._disabled;
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set placement(newValue) {
        this._popperPlacement = newValue;
        if (this._popperContent) {
            this._popperContent.popperOptions.placement = newValue;
            if (!this._shown) {
                return;
            }
            this._popperContent.popperInstance.setOptions(this._popperContent.popperOptions);
        }
    }
    /**
     * @return {?}
     */
    get placement() {
        return this._popperPlacement;
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set popperApplyArrowClass(newValue) {
        if (newValue === this._popperApplyArrowClass) {
            return;
        }
        this._popperApplyArrowClass = newValue;
        if (this._popperContent) {
            this._popperContent.popperOptions.applyArrowClass = newValue;
            if (!this._shown) {
                return;
            }
            this._popperContent.popperInstance.setOptions(this._popperContent.popperOptions);
        }
    }
    /**
     * @return {?}
     */
    get popperApplyArrowClass() {
        return this._popperApplyArrowClass;
    }
    /**
     * @param {?} target
     * @param {...?} sources
     * @return {?}
     */
    static assignDefined(target, ...sources) {
        for (const source of sources) {
            for (const key of Object.keys(source)) {
                /** @type {?} */
                const val = source[key];
                if (val !== undefined) {
                    target[key] = val;
                }
            }
        }
        return target;
    }
    /**
     * @return {?}
     */
    applyTriggerListeners() {
        switch (this.showTrigger) {
            case NgxPopperjsTriggers.click:
                this._pushListener("click", this.toggle.bind(this));
                break;
            case NgxPopperjsTriggers.mousedown:
                this._pushListener("mousedown", this.toggle.bind(this));
                break;
            case NgxPopperjsTriggers.hover:
                this._pushListener("mouseenter", this.scheduledShow.bind(this, this.showDelay));
                ["touchend", "touchcancel", "mouseleave"].forEach((/**
                 * @param {?} eventName
                 * @return {?}
                 */
                (eventName) => {
                    this._pushListener(eventName, this.scheduledHide.bind(this, null, this.hideTimeout));
                }));
                break;
        }
        if (this.showTrigger !== NgxPopperjsTriggers.hover && this.hideOnMouseLeave) {
            ["touchend", "touchcancel", "mouseleave"].forEach((/**
             * @param {?} eventName
             * @return {?}
             */
            (eventName) => {
                this._pushListener(eventName, this.scheduledHide.bind(this, null, this.hideTimeout));
            }));
        }
    }
    /**
     * @return {?}
     */
    getRefElement() {
        return this.targetElement || this._viewContainerRef.element.nativeElement;
    }
    /**
     * @return {?}
     */
    hide() {
        if (this.disabled) {
            return;
        }
        if (!this._shown) {
            this._overrideShowTimeout();
            return;
        }
        this._shown = false;
        if (this._popperContentRef) {
            this._popperContentRef.instance.hide();
        }
        else {
            this._popperContent.hide();
        }
        this.popperOnHidden.emit(this);
        this._clearGlobalEventListeners();
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    hideOnClickOutsideHandler($event) {
        // TODO: check if $event.target is a better alternative here
        if (this.disabled || !this.hideOnClickOutside || $event.srcElement &&
            $event.srcElement === this._popperContent.elRef.nativeElement ||
            this._popperContent.elRef.nativeElement.contains($event.srcElement)) {
            return;
        }
        this.scheduledHide($event, this.hideTimeout);
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    hideOnScrollHandler($event) {
        if (this.disabled || !this.hideOnScroll) {
            return;
        }
        this.scheduledHide($event, this.hideTimeout);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._subscriptions.forEach((/**
         * @param {?} sub
         * @return {?}
         */
        sub => sub.unsubscribe && sub.unsubscribe()));
        this._subscriptions.length = 0;
        this._clearEventListeners();
        this._clearGlobalEventListeners();
        this._scheduledShowTimeout && clearTimeout(this._scheduledShowTimeout);
        this._scheduledHideTimeout && clearTimeout(this._scheduledHideTimeout);
        this._popperContent && this._popperContent.clean();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        // Support legacy prop
        this.hideOnClickOutside = typeof this.hideOnClickOutside === "undefined" ?
            this.closeOnClickOutside : this.hideOnClickOutside;
        if (typeof this.content === "string") {
            this._popperContent = this._constructContent();
            this._popperContent.text = this.content;
        }
        else if (typeof this.content === typeof void 0) {
            this._popperContent = this._constructContent();
            this._popperContent.text = "";
        }
        else {
            this._popperContent = this.content;
        }
        /** @type {?} */
        const popperRef = this._popperContent;
        popperRef.referenceObject = this.getRefElement();
        this._setContentProperties(popperRef);
        this._setDefaults();
        this.applyTriggerListeners();
        if (this.showOnStart) {
            this.scheduledShow();
        }
    }
    /**
     * @param {?=} $event
     * @param {?=} delay
     * @return {?}
     */
    scheduledHide($event = null, delay = this.hideTimeout) {
        if (this.disabled) {
            return;
        }
        this._overrideShowTimeout();
        this._scheduledHideTimeout = setTimeout((/**
         * @return {?}
         */
        () => {
            // TODO: check
            /** @type {?} */
            const toElement = $event ? $event.toElement : null;
            /** @type {?} */
            const popperContentView = this._popperContent.popperViewRef ? this._popperContent.popperViewRef.nativeElement : false;
            if (!popperContentView ||
                popperContentView === toElement ||
                popperContentView.contains(toElement) ||
                (this.content && ((/** @type {?} */ (this.content))).isMouseOver)) {
                return;
            }
            this.hide();
            this._applyChanges();
        }), delay);
    }
    /**
     * @param {?=} delay
     * @return {?}
     */
    scheduledShow(delay = this.showDelay) {
        if (this.disabled) {
            return;
        }
        this._overrideHideTimeout();
        this._scheduledShowTimeout = setTimeout((/**
         * @return {?}
         */
        () => {
            this.show();
            this._applyChanges();
        }), delay);
    }
    /**
     * @return {?}
     */
    show() {
        if (this._shown) {
            this._overrideHideTimeout();
            return;
        }
        this._shown = true;
        /** @type {?} */
        const popperRef = this._popperContent;
        /** @type {?} */
        const element = this.getRefElement();
        if (popperRef.referenceObject !== element) {
            popperRef.referenceObject = element;
        }
        this._setContentProperties(popperRef);
        popperRef.show();
        this.popperOnShown.emit(this);
        if (this.timeoutAfterShow > 0) {
            this.scheduledHide(null, this.timeoutAfterShow);
        }
        this._globalEventListeners.push(this._renderer.listen("document", "touchend", this.hideOnClickOutsideHandler.bind(this)));
        this._globalEventListeners.push(this._renderer.listen("document", "click", this.hideOnClickOutsideHandler.bind(this)));
        // tslint:disable-next-line:max-line-length
        this._globalEventListeners.push(this._renderer.listen(this._getScrollParent(this.getRefElement()), "scroll", this.hideOnScrollHandler.bind(this)));
    }
    /**
     * @return {?}
     */
    toggle() {
        if (this.disabled) {
            return;
        }
        this._shown ? this.scheduledHide(null, this.hideTimeout) : this.scheduledShow();
    }
    /**
     * @private
     * @return {?}
     */
    _applyChanges() {
        this._changeDetectorRef.markForCheck();
        this._changeDetectorRef.detectChanges();
    }
    /**
     * @private
     * @return {?}
     */
    _clearEventListeners() {
        this._eventListeners.forEach((/**
         * @param {?} evt
         * @return {?}
         */
        evt => {
            evt && typeof evt === "function" && evt();
        }));
        this._eventListeners.length = 0;
    }
    /**
     * @private
     * @return {?}
     */
    _clearGlobalEventListeners() {
        this._globalEventListeners.forEach((/**
         * @param {?} evt
         * @return {?}
         */
        evt => {
            evt && typeof evt === "function" && evt();
        }));
        this._globalEventListeners.length = 0;
    }
    /**
     * @private
     * @return {?}
     */
    _constructContent() {
        /** @type {?} */
        const factory = this._resolver.resolveComponentFactory(this._popperContentClass);
        this._popperContentRef = this._viewContainerRef.createComponent(factory);
        return (/** @type {?} */ (this._popperContentRef.instance));
    }
    /**
     * @private
     * @param {?} node
     * @return {?}
     */
    _getScrollParent(node) {
        /** @type {?} */
        const isElement = node instanceof HTMLElement;
        /** @type {?} */
        const overflowY = isElement && window.getComputedStyle(node).overflowY;
        /** @type {?} */
        const isScrollable = overflowY !== "visible" && overflowY !== "hidden";
        if (!node) {
            return null;
        }
        else if (isScrollable && node.scrollHeight >= node.clientHeight) {
            return node;
        }
        return this._getScrollParent(node.parentNode) || document;
    }
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    _onPopperUpdate(event) {
        this.popperOnUpdate.emit(event);
    }
    /**
     * @private
     * @return {?}
     */
    _overrideHideTimeout() {
        if (this._scheduledHideTimeout) {
            clearTimeout(this._scheduledHideTimeout);
            this._scheduledHideTimeout = 0;
        }
    }
    /**
     * @private
     * @return {?}
     */
    _overrideShowTimeout() {
        if (this._scheduledShowTimeout) {
            clearTimeout(this._scheduledShowTimeout);
            this._scheduledHideTimeout = 0;
        }
    }
    /**
     * @private
     * @param {?} name
     * @param {?} cb
     * @return {?}
     */
    _pushListener(name, cb) {
        this._eventListeners.push(this._renderer.listen(this._elementRef.nativeElement, name, cb));
    }
    /**
     * @private
     * @param {?} popperRef
     * @return {?}
     */
    _setContentProperties(popperRef) {
        popperRef.popperOptions = NgxPopperjsDirective.assignDefined(popperRef.popperOptions, NgxPopperjsDirective.baseOptions, {
            showDelay: this.showDelay,
            disableAnimation: this.disableAnimation,
            disableDefaultStyling: this.disableStyle,
            placement: this.placement,
            boundariesElement: this.boundariesElement,
            trigger: this.showTrigger,
            positionFixed: this.positionFixed,
            popperModifiers: this.popperModifiers,
            ariaDescribe: this.ariaDescribe,
            ariaRole: this.ariaRole,
            applyClass: this.applyClass,
            applyArrowClass: this.popperApplyArrowClass,
            hideOnMouseLeave: this.hideOnMouseLeave,
            styles: this.styles,
            appendTo: this.popperAppendTo,
            preventOverflow: this.preventOverflow,
        });
        popperRef.onUpdate = this._onPopperUpdate.bind(this);
        this._subscriptions.push(popperRef.onHidden.subscribe(this.hide.bind(this)));
    }
    /**
     * @private
     * @return {?}
     */
    _setDefaults() {
        ["showDelay", "hideOnScroll", "hideOnMouseLeave", "hideOnClickOutside", "ariaRole", "ariaDescribe"].forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            this[key] = this[key] === void 0 ? NgxPopperjsDirective.baseOptions[key] : this[key];
        }));
        this.showTrigger = this.showTrigger === void 0 ? NgxPopperjsDirective.baseOptions.trigger : this.showTrigger;
        this.styles = this.styles === void 0 ? Object.assign({}, NgxPopperjsDirective.baseOptions.styles) : this.styles;
    }
}
NgxPopperjsDirective.ɵfac = function NgxPopperjsDirective_Factory(t) { return new (t || NgxPopperjsDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(NGX_POPPERJS_DEFAULTS)); };
NgxPopperjsDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NgxPopperjsDirective, selectors: [["", "popper", ""]], inputs: { hideTimeout: ["popperTimeout", "hideTimeout"], timeoutAfterShow: ["popperTimeoutAfterShow", "timeoutAfterShow"], applyClass: ["popperApplyClass", "applyClass"], content: ["popper", "content"], disabled: ["popperDisabled", "disabled"], placement: ["popperPlacement", "placement"], popperApplyArrowClass: "popperApplyArrowClass", hideOnClickOutside: ["popperHideOnClickOutside", "hideOnClickOutside"], showTrigger: ["popperTrigger", "showTrigger"], styles: ["popperStyles", "styles"], ariaDescribe: ["popperAriaDescribeBy", "ariaDescribe"], ariaRole: ["popperAriaRole", "ariaRole"], boundariesElement: ["popperBoundaries", "boundariesElement"], closeOnClickOutside: ["popperCloseOnClickOutside", "closeOnClickOutside"], disableAnimation: ["popperDisableAnimation", "disableAnimation"], disableStyle: ["popperDisableStyle", "disableStyle"], hideOnMouseLeave: ["popperHideOnMouseLeave", "hideOnMouseLeave"], hideOnScroll: ["popperHideOnScroll", "hideOnScroll"], popperAppendTo: "popperAppendTo", popperModifiers: "popperModifiers", positionFixed: ["popperPositionFixed", "positionFixed"], preventOverflow: ["popperPreventOverflow", "preventOverflow"], showDelay: ["popperDelay", "showDelay"], showOnStart: ["popperShowOnStart", "showOnStart"], targetElement: ["popperTarget", "targetElement"] }, outputs: { popperOnHidden: "popperOnHidden", popperOnShown: "popperOnShown", popperOnUpdate: "popperOnUpdate" } });
NgxPopperjsDirective.baseOptions = (/** @type {?} */ ({
    showDelay: 0,
    placement: NgxPopperjsPlacements.AUTO,
    hideOnClickOutside: true,
    hideOnMouseLeave: false,
    hideOnScroll: false,
    showTrigger: NgxPopperjsTriggers.hover,
    appendTo: undefined,
    ariaRole: "popper",
    ariaDescribe: "",
    styles: {}
}));
/** @nocollapse */
NgxPopperjsDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: ChangeDetectorRef },
    { type: ComponentFactoryResolver },
    { type: ElementRef },
    { type: Renderer2 },
    { type: undefined, decorators: [{ type: Inject, args: [NGX_POPPERJS_DEFAULTS,] }] }
];
NgxPopperjsDirective.propDecorators = {
    applyClass: [{ type: Input, args: ["popperApplyClass",] }],
    ariaDescribe: [{ type: Input, args: ["popperAriaDescribeBy",] }],
    ariaRole: [{ type: Input, args: ["popperAriaRole",] }],
    boundariesElement: [{ type: Input, args: ["popperBoundaries",] }],
    closeOnClickOutside: [{ type: Input, args: ["popperCloseOnClickOutside",] }],
    content: [{ type: Input, args: ["popper",] }],
    disableAnimation: [{ type: Input, args: ["popperDisableAnimation",] }],
    disabled: [{ type: Input, args: ["popperDisabled",] }],
    disableStyle: [{ type: Input, args: ["popperDisableStyle",] }],
    hideOnClickOutside: [{ type: Input, args: ["popperHideOnClickOutside",] }],
    hideOnMouseLeave: [{ type: Input, args: ["popperHideOnMouseLeave",] }],
    hideOnScroll: [{ type: Input, args: ["popperHideOnScroll",] }],
    hideTimeout: [{ type: Input, args: ["popperTimeout",] }],
    placement: [{ type: Input, args: ["popperPlacement",] }],
    popperAppendTo: [{ type: Input }],
    popperApplyArrowClass: [{ type: Input }],
    popperModifiers: [{ type: Input }],
    popperOnHidden: [{ type: Output }],
    popperOnShown: [{ type: Output }],
    popperOnUpdate: [{ type: Output }],
    positionFixed: [{ type: Input, args: ["popperPositionFixed",] }],
    preventOverflow: [{ type: Input, args: ["popperPreventOverflow",] }],
    showDelay: [{ type: Input, args: ["popperDelay",] }],
    showOnStart: [{ type: Input, args: ["popperShowOnStart",] }],
    showTrigger: [{ type: Input, args: ["popperTrigger",] }],
    styles: [{ type: Input, args: ["popperStyles",] }],
    targetElement: [{ type: Input, args: ["popperTarget",] }],
    timeoutAfterShow: [{ type: Input, args: ["popperTimeoutAfterShow",] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxPopperjsDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: "[popper]"
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: undefined, decorators: [{
                type: Inject,
                args: [NGX_POPPERJS_DEFAULTS]
            }] }]; }, { hideTimeout: [{
            type: Input,
            args: ["popperTimeout"]
        }], popperOnHidden: [{
            type: Output
        }], popperOnShown: [{
            type: Output
        }], popperOnUpdate: [{
            type: Output
        }], timeoutAfterShow: [{
            type: Input,
            args: ["popperTimeoutAfterShow"]
        }], applyClass: [{
            type: Input,
            args: ["popperApplyClass"]
        }], content: [{
            type: Input,
            args: ["popper"]
        }], disabled: [{
            type: Input,
            args: ["popperDisabled"]
        }], placement: [{
            type: Input,
            args: ["popperPlacement"]
        }], popperApplyArrowClass: [{
            type: Input
        }], hideOnClickOutside: [{
            type: Input,
            args: ["popperHideOnClickOutside"]
        }], showTrigger: [{
            type: Input,
            args: ["popperTrigger"]
        }], styles: [{
            type: Input,
            args: ["popperStyles"]
        }], ariaDescribe: [{
            type: Input,
            args: ["popperAriaDescribeBy"]
        }], ariaRole: [{
            type: Input,
            args: ["popperAriaRole"]
        }], boundariesElement: [{
            type: Input,
            args: ["popperBoundaries"]
        }], closeOnClickOutside: [{
            type: Input,
            args: ["popperCloseOnClickOutside"]
        }], disableAnimation: [{
            type: Input,
            args: ["popperDisableAnimation"]
        }], disableStyle: [{
            type: Input,
            args: ["popperDisableStyle"]
        }], hideOnMouseLeave: [{
            type: Input,
            args: ["popperHideOnMouseLeave"]
        }], hideOnScroll: [{
            type: Input,
            args: ["popperHideOnScroll"]
        }], popperAppendTo: [{
            type: Input
        }], popperModifiers: [{
            type: Input
        }], positionFixed: [{
            type: Input,
            args: ["popperPositionFixed"]
        }], preventOverflow: [{
            type: Input,
            args: ["popperPreventOverflow"]
        }], showDelay: [{
            type: Input,
            args: ["popperDelay"]
        }], showOnStart: [{
            type: Input,
            args: ["popperShowOnStart"]
        }], targetElement: [{
            type: Input,
            args: ["popperTarget"]
        }] }); })();
if (false) {
    /** @type {?} */
    NgxPopperjsDirective.baseOptions;
    /** @type {?} */
    NgxPopperjsDirective.prototype.ariaDescribe;
    /** @type {?} */
    NgxPopperjsDirective.prototype.ariaRole;
    /** @type {?} */
    NgxPopperjsDirective.prototype.boundariesElement;
    /** @type {?} */
    NgxPopperjsDirective.prototype.closeOnClickOutside;
    /** @type {?} */
    NgxPopperjsDirective.prototype.disableAnimation;
    /** @type {?} */
    NgxPopperjsDirective.prototype.disableStyle;
    /** @type {?} */
    NgxPopperjsDirective.prototype.hideOnClickOutside;
    /** @type {?} */
    NgxPopperjsDirective.prototype.hideOnMouseLeave;
    /** @type {?} */
    NgxPopperjsDirective.prototype.hideOnScroll;
    /** @type {?} */
    NgxPopperjsDirective.prototype.hideTimeout;
    /** @type {?} */
    NgxPopperjsDirective.prototype.popperAppendTo;
    /** @type {?} */
    NgxPopperjsDirective.prototype.popperModifiers;
    /** @type {?} */
    NgxPopperjsDirective.prototype.popperOnHidden;
    /** @type {?} */
    NgxPopperjsDirective.prototype.popperOnShown;
    /** @type {?} */
    NgxPopperjsDirective.prototype.popperOnUpdate;
    /** @type {?} */
    NgxPopperjsDirective.prototype.positionFixed;
    /** @type {?} */
    NgxPopperjsDirective.prototype.preventOverflow;
    /** @type {?} */
    NgxPopperjsDirective.prototype.showDelay;
    /** @type {?} */
    NgxPopperjsDirective.prototype.showOnStart;
    /** @type {?} */
    NgxPopperjsDirective.prototype.showTrigger;
    /** @type {?} */
    NgxPopperjsDirective.prototype.styles;
    /** @type {?} */
    NgxPopperjsDirective.prototype.targetElement;
    /** @type {?} */
    NgxPopperjsDirective.prototype.timeoutAfterShow;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._applyClass;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._content;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._disabled;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._eventListeners;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._globalEventListeners;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._popperApplyArrowClass;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._popperContent;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._popperContentClass;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._popperContentRef;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._popperPlacement;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._scheduledHideTimeout;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._scheduledShowTimeout;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._shown;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._subscriptions;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._viewContainerRef;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._changeDetectorRef;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._resolver;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._elementRef;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._renderer;
    /**
     * @type {?}
     * @private
     */
    NgxPopperjsDirective.prototype._popperDefaults;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-popperjs.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?=} config
 * @return {?}
 */
function provideNgxPopperjsOptions(config = {}) {
    return [
        { provide: NGX_POPPERJS_DEFAULTS, useValue: config },
    ];
}
class NgxPopperjsModule {
    /**
     * @param {?=} popperBaseOptions
     * @return {?}
     */
    static forRoot(popperBaseOptions) {
        return {
            ngModule: NgxPopperjsModule,
            providers: [
                provideNgxPopperjsOptions(popperBaseOptions)
            ]
        };
    }
}
NgxPopperjsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxPopperjsModule });
NgxPopperjsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxPopperjsModule_Factory(t) { return new (t || NgxPopperjsModule)(); }, providers: [
        provideNgxPopperjsOptions()
    ], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxPopperjsModule, { declarations: function () { return [NgxPopperjsContentComponent, NgxPopperjsDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxPopperjsContentComponent, NgxPopperjsDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxPopperjsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    NgxPopperjsContentComponent,
                    NgxPopperjsDirective
                ],
                entryComponents: [
                    NgxPopperjsContentComponent
                ],
                exports: [
                    NgxPopperjsContentComponent,
                    NgxPopperjsDirective
                ],
                providers: [
                    provideNgxPopperjsOptions()
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ngx-popperjs.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxPopperjsContentComponent, NgxPopperjsDirective, NgxPopperjsModule, NgxPopperjsPlacements, NgxPopperjsTriggers, provideNgxPopperjsOptions, NGX_POPPERJS_DEFAULTS as ɵa };

//# sourceMappingURL=ngx-popperjs.js.map